import { React, useEffect, useState, createContext, useMemo, useCallback, useRef } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react"; //, the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAuthToken } from "../api/api";
import AddContract from "../bootstrap/AddContract";
import { getUserDetails } from "../components/sidebar/Sidenav";
import { getAPIUrl, notify, suppressKeyboardEvent } from "../components/common/helpers";
import { ContractDetailsCellRenderer } from "../components/common/CustomCellRenderer";
import CustomDetailsComponent from "../components/common/CustomDetailsComponent";
import "../styles/Modal.css";
import styled from "styled-components";

const StyledReleaseDetails = styled.div`
  .btn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
  
  .Deletebtn {
    background: transparent;
    border: none;
    color: white;
  }
  .Deletebtn:hover {
    background: transparent;
    border: none;
  }
  .Deletebtn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;

const ContractContext = createContext();
export default function ContractManagement(props) {
  const { disabledFeatures } = props;
  const [gridEntries, setGridEntries] = useState();
  const [moreReleaseInfo, setMoreReleaseInfo] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [field, setField] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [edit, setEdit] = useState(false);
  const [recordValues, setRecordValues] = useState();
  const [title, setTitle] = useState("");
  const gridRef = useRef();

  const controller = new AbortController();

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    document.title = "Contract Management";
    if(gridApi) {
      getContracts();
    }
    return () => {
      controller.abort();
    };
   }, [gridApi]);

   const createServerRequest = (params) => {
    const {startRow, endRow, filterModel, sortModel} = params;
    let sortQuery = '';
    let filterParams = '';
    let statusQuery = '';
    if (sortModel && sortModel.length > 0 && sortModel !== undefined) {
     sortQuery = `&sortColumn=${sortModel[0].colId}&sortOrder=${sortModel[0].sort}`;
    }
    if (Object.keys(filterModel).length > 0) {
     filterParams = Object.keys(filterModel).map(field => {
       const filter = filterModel[field];
       return `&${field}=${filter.filter}`
     }).join('');
    }
    return `?filter_page=${startRow}&filter_pageSize=${endRow}${filterParams}${sortQuery}${statusQuery}`;
}

const showErrorOverlay = (gridApi) => {
  if (gridApi) {
    gridApi.showNoRowsOverlay();
  }
};

const handleApiError = (gridApi) => {
    showErrorOverlay(gridApi);
};

    const handleDeleteContract = async (field) => {
        const {contract_number, contract_id } = field;
        const msg = `Are you sure, you want to delete Contract ${contract_number}`;
        const confirm = window.confirm(msg);
        if (confirm) {
          const body = JSON.stringify({
            contract_id,
            title: "SiteContract",
            updated_by: getUserDetails().username,
          });
          await axios({
            method: "PATCH",
            url: getAPIUrl("deleteFunctionApi"),
            headers: { Authorization: getAuthToken()},
            signal: controller.signal,
            data: body
          })
            .then((resp) => {
              if (resp){
                getContracts();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };

  const handleEdit = (field) => {
    setEdit(true);
    setRecordValues(field);
  };

  const handleContractDetails = (field) => {
    setReadOnly(true);
    setGridEntries(field);
    setTitle(`Details of Site - ${field.building_name}`);
  }

  const column = [
    {
      headerName: "Contract Id",
      field: "contract_id",
      floatingFilter: true,
      width: 100,
    },
    {
        headerName: "Contract Number",
        field: "contract_number",
        floatingFilter: true,
        width: 100,
      },
    {
      headerName: "Site",
      field: "building_name",
      floatingFilter: true,
      width: 100,
    },
    {
      headerName: "Site Id",
      field: "site_id",
      floatingFilter: true,
      width: 100,
    },
      {
        headerName: "Details",
        colId: "details",
        minWidth: 100,
        cellRenderer: ContractDetailsCellRenderer,
        cellRendererParams: {
         type : "info",
         handleContractDetails
        }
      },
      {
        headerName: "Action",
        hide: disabledFeatures.includes("AddContract"),
        field: "release_details_id",
        width: 250,
        colId: "action",
        minWidth: 150,
        cellRenderer: ContractDetailsCellRenderer,
        cellRendererParams: {
         type:"edit",
         disabledFeatures: disabledFeatures,
         handleDeleteContract,
         handleEdit
        }
      },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    flex: 1,
    resizable: true,
    minWidth: 110,
    suppressKeyboardEvent
  };

  const requiredKeys = {
    component_types: "Component Types",
    created_date: "Created Date", 
    created_by: "Created By",
    updated_by : "Updated By",
    updated_date : "Updated Date"
    };

  const getContracts = async () => {
    if(!gridApi) return;
    const dataSource = {
      getRows: (params) => {
        const requestParameters = createServerRequest(params);
        gridApi.showLoadingOverlay();
        axios({
          method: "GET",
          url: getAPIUrl("getSiteContractDetails") + requestParameters,
          headers: {
            Authorization: getAuthToken(),
          },
          signal: controller.signal,
        })
        .then((res) => {
          if (res && res.data.contractDetails.length > 0) {
            const responseData = res.data.contractDetails.map((item) => ({
              ...item
            }));
            params.successCallback(responseData,  res.data.lastRow);
            gridApi.hideOverlay();
          } 
          else {
            params.successCallback([], 0);
            handleApiError(gridApi);
          }
        })
        .catch((err) => {
          params.successCallback([],  0);
          params.failCallback();
          handleApiError(gridApi);
          err.message !== "canceled" && notify("fetching");
        });
    }
  }
    gridApi.setDatasource(dataSource);
  };
   
  return (
    <StyledReleaseDetails>
      <h4 className="text-white p-2">Contract Management</h4>
      <div
        className="container-fluid"
        style={{
          background: "#1F1F1F 0% 0% no-repeat padding-box",
          border: "1px solid #707070",
          width: "100%",
        }}
      >
        <div className="text-end py-2">
        <AddContract
            disabledFeatures={disabledFeatures}
            getContracts={getContracts}
            isEdit={false}
          />
        </div>
        <div className="text-end py-2">
            {readOnly && <CustomDetailsComponent 
            gridEntries= {gridEntries}
            readOnly = {readOnly}
            setReadOnly= {setReadOnly}
            requiredKeys= {requiredKeys}
            title ={title}
              /> }
        </div>
        <div
          className="ag-theme-alpine-dark"
          style={{ height: 545, width: "100%" }}
        >
          {edit && (
            <AddContract
              disabledFeatures={disabledFeatures}
              getContracts={getContracts}
              isEdit={edit}
              setEdit={setEdit}
              rowEntries={recordValues}
            />
          )}
          <AgGridReact
            onGridReady={onGridReady}
            ref={gridRef}
            rowModelType={"infinite"}
            columnDefs={column}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={10}
            cacheBlockSize={10}
            filter= {true}
            sortable={true}
          ></AgGridReact>
        </div>

        <div className="py-2"></div>
      </div>
      <ToastContainer
        style={{ width: "50%" }}
        closeOnClick={false}
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        limit={1}
      />
    </StyledReleaseDetails>
  );
}

export { ContractContext };
